import React, { createContext, useState, useContext, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;
const JobsContext = createContext();

export const JobsProvider = ({ children }) => {
  const [jobsData, setJobsData] = useState({
    bids: [],
    jobsInProgress: [],
    completedJobsNotInvoiced: [],
    invoicedJobs: [],
    invoicedPile: [],
    paidJobs: [],
    cancelledJobs: []
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchBidJobs = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=BID';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            bids: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchJobsInProgress = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=IPG';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            jobsInProgress: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchCompletedJobsNotInvoiced = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=CMP';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            completedJobsNotInvoiced: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchInvoicedJobs = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=INV';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            invoicedJobs: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchInvoicedPile = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=IPR';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            invoicedPile: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchJobsPaid = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=IPD';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            paidJobs: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

const fetchCancelledJobs = () => {
    const token = localStorage.getItem('access_token');
    const headers = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    });

    const url =  API_BASE + '/api/jobs/?format=json&status=CNL';

    fetch(url, {
        method: 'GET',
        headers: headers,
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        setJobsData(prevJobsData => ({
            ...prevJobsData,
            cancelledJobs: data
        }));
    })
    .catch(error => console.error('Error fetching data:', error));
};

  const refreshTables = () => {
    // Fetch functions to update jobs data
    return Promise.all([
        fetchBidJobs(),
        fetchJobsInProgress(),
        fetchCompletedJobsNotInvoiced(),
        fetchInvoicedJobs(),
        fetchInvoicedPile(),
        fetchJobsPaid(),
        fetchCancelledJobs()
      ])
      .finally(() => {
        // Once *all* fetch calls finish (success/fail), set isLoading to false
        setIsLoading(false);
    });
  };

  useEffect(() => {
    refreshTables();
  }, []);

  return (
    <JobsContext.Provider value={{ jobsData, refreshTables, isLoading }}>
      {children}
    </JobsContext.Provider>
  );
};

export const useJobs = () => {
  return useContext(JobsContext);
};
